export default "__VITE_ASSET__1a239e12__"